import {
  FileSizeLimit,
  FileType,
  FileUploadType,
  getFileTypeIcon,
  getMbFileLimit,
} from '@payaca/helpers/fileHelper';
import { TIconName } from '@payaca/untitled-icons';

export { FileSizeLimit, FileType, FileUploadType, getMbFileLimit };

export const findTypeAndIconFromMimeType = (
  mimeType: string
): [string, TIconName] => {
  switch (true) {
    case mimeType.startsWith('image/'):
      return ['Image', 'image-01.3'];
    case mimeType.startsWith('video/'):
      return ['Video', 'video-recorder.3'];
    case mimeType === 'application/pdf':
      return ['PDF', 'pdf'];
    default:
      return ['Other', 'file-attachment-03.3'];
  }
};
